import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { getFavouritesCompare } from 'Queries'
import FavouriteCardOOS from './FavouriteCardOOS'
import { Loading } from '../component'
import { Grid, ArticleProductCard } from 'Blocks'

const OosProducts = ({ uuids, removeFavourite, className, screenType }) => {
  function removeFromFavs(productId, msg) {
    if (productId) {
      console.log(msg, productId)
      removeFavourite(productId)
    }
  }
  const GET_FAVOURITES_COMPARE = getFavouritesCompare(uuids)
  const { data, loading } = useQuery(GET_FAVOURITES_COMPARE, {
    errorPolicy: 'all'
  })

  if (loading) return <Loading className={className} />

  const itemsPerRow = screenType === 'small' ? 2 : 4

  const products = []

  Object.keys(data).forEach((result, index) => {
    const productExists = !!data[result]

    if (productExists) {
      const hasCompareResults = !!data[result].products.length
      if (hasCompareResults) {
        products.push({ ...data[result] })
      } else {
        const prodId = get(data[result], 'product.uuid', false)
        removeFromFavs(
          prodId,
          'the product is oos and no alternatives.. remove from localstorage favourites: '
        )
      }
    } else {
      const prodId = uuids[index]
      removeFromFavs(
        prodId,
        'the product is does not exist.. remove from localstorage favourites: '
      )
    }
  })

  return products.length > 0 ? (
    <div className="oos__section">
      <h2 className="oos__title">Some of your favourites are out of stock.</h2>
      <h3 className="oos__sub-title">{`We've found some alternatives...`}</h3>
      <div className="oos__products">
        {products.map((product, i) => (
          <div
            className="oos__product"
            key={`oosp-${product.product.uuid}-${i}`}
          >
            <FavouriteCardOOS
              product={product.product}
              removeFavourite={removeFavourite}
            />
            <Grid {...{ itemsPerRow }}>
              {product.products.map((product, index) => (
                <ArticleProductCard
                  key={`inneroosgrid-${product.uuid}-${index}`}
                  cardContext="OOS Modal"
                  product={product}
                />
              ))}
            </Grid>
          </div>
        ))}
      </div>
    </div>
  ) : null
}

OosProducts.propTypes = {
  uuids: PropTypes.array,
  removeFavourite: PropTypes.func,
  className: PropTypes.string,
  screenType: PropTypes.string
}

export default OosProducts
